import React from 'react';
import App from './app';
import './sa';
import { createRoot } from 'react-dom/client';
import './assets/css/global.scss';
import setBooheeSeeConfig from 'tools/boohee-see';

setBooheeSeeConfig();

if (/console=true/.test(window.location) || localStorage.getItem('active-eruda') === 'true') {
  import('vconsole').then(({ default: VConsole }) => {
    new VConsole();
  });
}

class GlobalErrorBoundary extends React.Component {
  componentDidCatch(error) {
    if (window.$BooheeSender) {
      window.$BooheeSender?.reportError(error);
    }
  }

  render() {
    return this.props.children;
  }
}

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
  <GlobalErrorBoundary>
    <App />
  </GlobalErrorBoundary>
);

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
}
